import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ErrorMessage} from "../sara-input/error-message";
import {InputRadioMessages} from "./input-radio-messages";

@Component({
    selector: 'sara-radio',
    templateUrl: './sara-radio.component.html',
})
export class SaraRadioComponent {

    @Input() error:ErrorMessage;
    @Input() name:string;
    @Input() show:boolean;
    @Input() item:any;
    @Output() change:EventEmitter<any> = new EventEmitter<any>();

    @Output() modelChange: EventEmitter<string> = new EventEmitter();

    modelValue = "";

    @Input()
    get model() {
        return this.modelValue;
    }

    set model(val) {
        this.modelValue = val;
        this.modelChange.emit(this.modelValue);
    }

    doChange(){
        if(!!this.change){
            this.change.next();
        }
    }

    constructor(){
    }

    updateValidation = function () {

    }
}



// WEBPACK FOOTER //
// ./public/upgrade/shared/sara-radio/sara-radio.component.ts